import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { HighlightedPhrase } from '../../HighlightedPhrase/HighlightedPhrase.tsx';

const DEFAULT_FIELD_HEIGHT = '28px';

type FieldValueProps = {
  name: string;
  searchPhrase?: string;
  value?: string | null;
};

export const FieldValue = ({ name, searchPhrase, value }: FieldValueProps) => (
  <Stack
    data-test="field-value"
    direction="row"
    sx={{
      alignItems: 'center',
      gap: 1,
      height: DEFAULT_FIELD_HEIGHT,
      maxWidth: '100%',
      minWidth: 0,
    }}
  >
    <Typography color="textSecondary" sx={{ whiteSpace: 'nowrap', wordBreak: 'keep-all' }} variant="body2">
      {name}:
    </Typography>
    <Tooltip title={value || ''}>
      <Typography noWrap variant="body2">
        {value ? <HighlightedPhrase searchPhrase={searchPhrase}>{value}</HighlightedPhrase> : 'N / A'}
      </Typography>
    </Tooltip>
  </Stack>
);
